import {
  AccountActionConstants,
  MenuActionConstants,
  SearchActionConstants,
  SettingsActionConstants,
  UIActionConstants
} from "../action-constants";
import {
  AccountSelectors,
  MenuSelectors,
  OverlaySelectors,
  SearchSelectors,
  SettingsSelectors,
  UISelectors
} from "../selectors";
import { OverlayActionCreators } from "../action-creators";
import { TrackingUtils } from "../../utils";
import { WidgetActionCloseSuccess } from "../../constants";

export const OverlayMiddleware = store => next => action => {
  next(action);

  const onRightSideDrawerChange = payload => {
    const rightSideDrawer = UISelectors.rightSideDrawer(store.getState());
    const overlays = OverlaySelectors.overlays(store.getState());
    let activeWidgetsOverlay = [];
    let options;

    for (let drawer of rightSideDrawer) {
      if (drawer.isVisible && !drawer.isMinimized) {
        activeWidgetsOverlay.push(drawer.appID);
        if (!options) {
          options = {
            identifier: drawer.appID,
            className: "right-drawer-show"
          };
        }
      }
    }

    const isDisplayed = activeWidgetsOverlay.length > 0;
    if (isDisplayed) {
      store.dispatch(OverlayActionCreators.show(options));
    } else {
      TrackingUtils.sendAnalytics({
        dataCategory: "client overlay",
        dataAction: "click",
        dataLabel:
          WidgetActionCloseSuccess[
            Object.keys(WidgetActionCloseSuccess).find(
              name => name === payload.appID
            )
          ] ?? ""
      });

      // check for hiding overlays
      for (let overlay of overlays) {
        const { identifier } = overlay;
        if (!activeWidgetsOverlay.includes(identifier)) {
          store.dispatch(
            OverlayActionCreators.hide({ identifier: identifier })
          );
        }
      }
    }
  };

  switch (action.type) {
    case AccountActionConstants.TOGGLE_ACCOUNT_DRAWER: {
      const drawerActive = AccountSelectors.drawerActive(store.getState());

      const action = drawerActive
        ? OverlayActionCreators.show()
        : OverlayActionCreators.hide();
      store.dispatch(action);
      break;
    }

    case SettingsActionConstants.GENERAL.TOGGLE_DRAWER: {
      const drawerActive = SettingsSelectors.general.isDrawerActive(
        store.getState()
      );

      const action = drawerActive
        ? OverlayActionCreators.show({ className: "generic-drawer-show" })
        : OverlayActionCreators.hide();

      store.dispatch(action);
      break;
    }

    case AccountActionConstants.TOGGLE_MINI_CASHIER_DRAWER: {
      const miniCashierDrawerActive = AccountSelectors.miniCashierDrawerActive(
        store.getState()
      );

      const action = miniCashierDrawerActive
        ? OverlayActionCreators.show()
        : OverlayActionCreators.hide();
      store.dispatch(action);

      break;
    }

    case SearchActionConstants.TOGGLE_SEARCH_DRAWER: {
      const searchActive = SearchSelectors.searchActive(store.getState());

      const action = searchActive
        ? OverlayActionCreators.show({ className: "searchShow" })
        : OverlayActionCreators.hide();
      store.dispatch(action);

      break;
    }

    case MenuActionConstants.HIDE_LANGUAGE_MENU:
    case MenuActionConstants.SHOW_LANGUAGE_MENU: {
      const languageMenuVisible = MenuSelectors.languageMenuVisible(
        store.getState()
      );

      const action = languageMenuVisible
        ? OverlayActionCreators.show()
        : OverlayActionCreators.hide();
      store.dispatch(action);
      break;
    }
    case MenuActionConstants.HIDE_ODDS_MENU:
    case MenuActionConstants.SHOW_ODDS_MENU: {
      const oddsMenuVisible = MenuSelectors.oddsMenuVisible(store.getState());

      const action = oddsMenuVisible
        ? OverlayActionCreators.show()
        : OverlayActionCreators.hide();
      store.dispatch(action);
      break;
    }

    case MenuActionConstants.SHOW_QUICK_LINKS_INNER_MENU: {
      store.dispatch(OverlayActionCreators.show());
      break;
    }

    case MenuActionConstants.HIDE_QUICK_LINKS_INNER_MENU: {
      store.dispatch(OverlayActionCreators.hide());
      break;
    }

    case MenuActionConstants.HIDE_APPEARANCE_MENU:
    case MenuActionConstants.SHOW_APPEARANCE_MENU: {
      const appearanceMenuVisible = MenuSelectors.appearanceMenuVisible(
        store.getState()
      );

      const action = appearanceMenuVisible
        ? OverlayActionCreators.show()
        : OverlayActionCreators.hide();
      store.dispatch(action);
      break;
    }

    case MenuActionConstants.SHOW_HAMBURGER_MENU:
    case MenuActionConstants.HIDE_HAMBURGER_MENU: {
      const hamburgerMenuVisible = MenuSelectors.hamburgerMenuVisible(
        store.getState()
      );

      const drawersRendering = MenuSelectors.drawersRendering(store.getState());

      const action =
        hamburgerMenuVisible && !drawersRendering
          ? OverlayActionCreators.show()
          : OverlayActionCreators.hide();
      store.dispatch(action);
      break;
    }

    case UIActionConstants.ADD_ELEMENT_RIGHT_SIDE_DRAWER:
    case UIActionConstants.REMOVE_ELEMENT_RIGHT_SIDE_DRAWER:
    case UIActionConstants.UPDATE_RIGHT_SIDE_DRAWER: {
      const { payload } = action;
      onRightSideDrawerChange(payload);
      break;
    }

    default: {
      break;
    }
  }
};
